import { portal } from '../lib/portal';

/**
 * Shared query options for the arrival-information read (Task #1673), used by
 * both ArrivalInformationCard (dashboard) and ArrivalInformationPage
 * (/arrival-information). One queryKey + staleTime here means navigating from
 * the card to the page reuses the cached payload instead of refetching.
 *
 * Returned as plain options (not a wrapped useQuery) so each consumer keeps
 * its own select/enabled freedom and the hook has nothing to mock in tests
 * beyond `portal.arrivalInformation`.
 *
 * staleTime is 5 minutes: placement details change on Globus's cadence
 * (staff-driven), not the applicant's — a reload boundary of minutes is fine
 * and avoids hammering the Hub from the dashboard.
 */
export function useArrivalInformation() {
  return {
    queryKey: ['arrival-information'] as const,
    queryFn: () => portal.arrivalInformation(),
    staleTime: 5 * 60 * 1000,
  };
}
